import { render, staticRenderFns } from "./gasLeakDetectionAlarmTab.vue?vue&type=template&id=e79fab86"
import script from "./gasLeakDetectionAlarmTab.vue?vue&type=script&lang=js"
export * from "./gasLeakDetectionAlarmTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e79fab86')) {
      api.createRecord('e79fab86', component.options)
    } else {
      api.reload('e79fab86', component.options)
    }
    module.hot.accept("./gasLeakDetectionAlarmTab.vue?vue&type=template&id=e79fab86", function () {
      api.rerender('e79fab86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/lbe/glda/gasLeakDetectionAlarmTab.vue"
export default component.exports